import styled from 'styled-components';

export const Message = styled.div`
  margin-left: 0.5rem;
`;
